export default function AdminFooter() {

    const year = new Date().getFullYear();

    return (
        <footer className="px-4 sm:px-6 lg:px-8 py-6 text-center text-xs text-gray-400">
            <span className="font-bold tracking-widest text-gray-500">GMT-3</span>
            <span className="mx-2">·</span>
            <span>{year}</span>
        </footer>
    )
}
